import { isElevatedCampaignPromoSeries } from '../constants/elevatedCampaignPromoUi';
import { getSelfServeCampaignPromotion } from './campaignDiscount';
import {
  capturePromoSeriesFromUrl,
  resolveActivePromoSeries,
} from './campaignPromo';

/**
 * Single switch for campaign promo UI (landing banner, 50% landing sections, checkout
 * discount preview). Active when a campaign id is available from, in order:
 * `?promoSeries=` (HGPRO), build-time NEXT_PUBLIC_SELF_SERVE_PROMO_SERIES (direct
 * self-serve — no session required), then sessionStorage from a prior HGPRO visit.
 *
 * @returns {string | null}
 */
export function getSelfServeCampaignPromoSeries() {
  capturePromoSeriesFromUrl();
  const campaignId = resolveActivePromoSeries();
  if (!campaignId || !isElevatedCampaignPromoSeries(campaignId)) {
    return null;
  }
  if (!getSelfServeCampaignPromotion(campaignId)) {
    return null;
  }
  return campaignId;
}

/** @deprecated Prefer getSelfServeCampaignPromoSeries */
export function getActiveElevatedCampaignId() {
  return getSelfServeCampaignPromoSeries();
}

export function isSelfServeCampaignPromoActive() {
  return Boolean(getSelfServeCampaignPromoSeries());
}

/** @deprecated Prefer isSelfServeCampaignPromoActive */
export function isElevatedCampaignActive() {
  return isSelfServeCampaignPromoActive();
}
